import { connect } from 'react-redux';
import { addNoticeTemplate, editNoticeTemplate } from '../../../../actions/NoticeTemplates';
import { hideNoticeTemplateModal } from '../../../../actions/Modal';
import NoticeTemplateDialog from './NoticeTemplateDialog';

const mapStateToProps = ({ modal }) => ({
  isOpen: modal.noticeTemplateModal.visible,
  template: modal.noticeTemplateModal.template,
  isLoading: modal.noticeTemplateModal.isLoading,
});

export default connect(
  mapStateToProps,
  {
    addNoticeTemplate,
    editNoticeTemplate,
    hideNoticeTemplateModal,
  },
)(NoticeTemplateDialog);
